module.exports = __webpack_public_path__ + "static/media/top-green.b20221dc.png";